export const environment = {
  production: true,
  api: 'https://#{App}#/api',
  environment: '#{Sentry:Environment}#',
  sentry: 'https://aad250c18dc344fabf59729b560c0071@sentry.io/1186310',
  tenant: '#{Azure:TenantId}#',
  clientId: '#{Azure:ClientId}#'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts